import React, { useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './InnerPage.css';

export default function PrivacyPage() {
      const { t } = useLanguage();
      
      useEffect(() => {
            window.scrollTo(0, 0);
      }, []);

      return (
            <div className="inner-page">
                  <Navbar />

                  <section className="inner-page__hero">
                        <div className="inner-page__hero-inner">
                              <div className="inner-page__tag">{t('privacy.tag')}</div>
                              <h1 className="inner-page__title">{t('privacy.title')}</h1>
                              <p className="inner-page__subtitle">
                                    {t('privacy.subtitle')}
                              </p>
                        </div>
                  </section>

                  <div className="inner-page__content">

                        <div className="content-card">
                              <h2 className="content-card__title">{t('privacy.section1Title')}</h2>
                              <p>{t('privacy.section1Text1')}</p>
                              <p>{t('privacy.section1Text2')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('privacy.section2Title')}</h2>
                              <p>{t('privacy.section2Text')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('privacy.section3Title')}</h2>
                              <p>{t('privacy.section3Text1')}</p>
                              <p>{t('privacy.section3Text2')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('privacy.section4Title')}</h2>
                              <p>{t('privacy.section4Text')}</p>
                        </div>

                        <div className="content-card">
                              <h2 className="content-card__title">{t('privacy.contactTitle')}</h2>
                              <p>{t('privacy.contactText')}</p>
                              <a href="mailto:admin@agrollama.com" className="contact-highlight" id="privacy-contact-email">
                                    {t('privacy.contactEmail')}
                              </a>
                        </div>

                  </div>

                  <Footer />
            </div>
      );
}
